import "core-js/modules/es6.object.keys.js";
import Config from "./warningConfig";
export var warningConfig = Config;
var warned = {};
export function isShouldUpdate(component, props) {
  var config = Config[component];
  if (!config) return;
  var keys = Object.keys(config);
  var flag = false;
  var msg = "[Tinper] Some '".concat(component, "' properties will be deprecated: \n");
  keys.forEach(function (item) {
    if (props[item]) {
      msg += " '".concat(item, "', please use '").concat(config[item], "' instead. \n");
      flag = true;
    }
  });
  flag && warningOnce(false, msg);
}
export function warning(valid, message) {
  if (process.env.NODE_ENV !== "production" && !valid && console !== undefined) {
    console.error("Warning: ".concat(message));
  }
}
export function note(valid, message) {
  // Support uglify
  if (process.env.NODE_ENV !== "production" && !valid && console !== undefined) {
    console.warn("Note: ".concat(message));
  }
}
export function resetWarned() {
  warned = {};
}
export function call(method, valid, message) {
  if (!valid && !warned[message]) {
    method(false, message);
    warned[message] = true;
  }
}
export function warningOnce(valid, message) {
  call(warning, valid, message);
}
export function noteOnce(valid, message) {
  call(note, valid, message);
}
export var devWarning = function devWarning(valid, component, message) {
  warningOnce(valid, "[tinper: ".concat(component, "] ").concat(message));
};


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-core/src/warning.js